/**
 * Click tracking for the "Chat with us on WhatsApp" link
 * (snippets/whatsapp-cta.liquid, TY-080).
 *
 * Pushes `whatsapp_click` to the dataLayer; a GTM Custom Event trigger on it
 * forwards the click to GA4.
 *
 * Loaded site-wide from snippets/scripts.liquid rather than inline in the
 * snippet: on collection pages quick-add copies the product page's buy box
 * (link included) into a modal, and inline scripts in that copied HTML never
 * run. One delegated listener on document covers every copy of the link.
 *
 * Kept ES2017-clean (no optional chaining), like build-your-ring.js: a parse
 * error on older iOS Safari would discard the whole file.
 */
(function () {
  if (window.lohrWhatsappCtaBound) return;
  window.lohrWhatsappCtaBound = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    var link = target && target.closest ? target.closest('[data-whatsapp-cta]') : null;
    if (!link) return;

    // The copy inside the quick-add modal still carries the product page's
    // location, so report where it was actually clicked.
    var ctaLocation = link.closest('#quick-add-dialog') ? 'quick_add' : link.getAttribute('data-cta-location');

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'whatsapp_click',
        cta_location: ctaLocation,
        product_id: link.getAttribute('data-product-id'),
        product_name: link.getAttribute('data-product-name'),
      });
    } catch (e) {
      // never let tracking block the chat from opening
    }
  });
})();
